import BookingForm from '@bookings/components/booking-form/booking-form.vue';
import { Resource } from '@modules/centers/interfaces/resource';
import TableHeader from '@shared/components/tables/table-header/table-header.vue';
import { Component, Watch } from 'vue-property-decorator';
import FullCalendar, { CalendarOptions, DateSelectArg, EventApi } from '@fullcalendar/vue';
// import { Calendar } from '@fullcalendar/core';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import scrollGrid from '@fullcalendar/scrollgrid';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { BookingEvent } from '@bookings/interfaces/booking-event';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import TableFooter from '@shared/components/tables/table-footer/table-footer.vue';
import { Discipline } from '@centers/interfaces/discipline';
import moment from 'moment';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { set } from 'lodash';
import { Booking } from '@bookings/interfaces/booking';
import StdxForm from '@shared/components/forms/auto-form/stdx-form/stdx-form.vue';
import VuexFormProvider from '@shared/components/forms/auto-form/vuex-form-provider/vuex-form-provider';
import { Calendar } from '@fullcalendar/core';
import { Observable, Subscription } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import tippy from 'tippy.js';
import CalendarDisciplineFilter from '@shared/components/forms/inputs/calendar-discipline-filter/calendar-discipline-filter.vue';
import DrawerBookingForm from '@bookings/components/drawer-booking-form/drawer-booking-form.vue';
import DrawerBookingEventForm from '@bookings/components/drawer-booking-event-form/drawer-booking-event-form.vue';
import router from '@app/router/index.APP_TARGET';
import { ScheduleSlotRange } from '@bookings/interfaces/schedule-slot-range';
import { ParsedEvent } from '@bookings/interfaces/calendar';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import adaptivePlugin from '@fullcalendar/adaptive';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import BookingEventRefuseModal from '@bookings/components/booking-event-refuse-modal/booking-event-refuse-modal.vue';
import BookingEventConfirmModal from '@bookings/components/booking-event-confirm-modal/booking-event-confirm-modal.vue';

@Component({
  name: 'bpc-booking-event-calendar-page',
  components: {
    'full-calendar': FullCalendar,
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-table-header': TableHeader,
    'bpc-table-footer': TableFooter,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-entity-select': EntitySelect,
    'bpc-select': Select,
    'bpc-stdx-form': StdxForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-booking-event-form': DrawerBookingEventForm,
    'bpc-drawer-booking-form': DrawerBookingForm,
    'bpc-calendar-discipline-filter': CalendarDisciplineFilter,
    'bpc-std-form': StdForm,
    'bpc-switch': Switch,
    'bpc-booking-event-refuse-modal': BookingEventRefuseModal,
    'bpc-booking-event-confirm-modal': BookingEventConfirmModal,
  },
})
export default class BookingEventCalendar extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    eventForm: InstanceType<typeof StdxForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;

      extraData: string | AnyEntity;
      formProvider: VuexFormProvider;
    };
    fcalendar: InstanceType<typeof FullCalendar> & {
      $emit(event): void;
      getApi(): Calendar;
    };
    bookingForm: InstanceType<typeof BookingForm> & {
      clickOnSaveButton: () => Promise<string>;
      clickOnSearchButton: () => Promise<string>;
      clickOnReplaceButton: () => Promise<string>;
    };
    stdCancelForm: InstanceType<typeof StdForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
    };
  };

  public get showCancelButton(): boolean {
    return true;
  }

  public entity: Booking = null;

  public resourcesLoaded: boolean = false;
  public resources: Resource[] = [];

  public disciplinesLoaded: boolean = false;
  public disciplines: Discipline[] = [];

  public items: BookingEvent[] = [];
  // public allEvents: any[] = [];

  public events: ParsedEvent[] = [];
  public excludedEvents: ParsedEvent[] = [];
  public backgroundEvents: ParsedEvent[] = [];

  public entityName = 'booking-event';
  public pluralEntityName = 'booking-events';
  public permissionEntityNameToUse = 'bookings';

  public bookingFormModelChanged: boolean = false;

  public selectedRowEntity = null;
  public cancelFormConfigName = 'cancel-events';

  loadingConflicts = false;
  loadingSlotCategories = false;
  resourceConflictSubscription: Subscription;
  slotPricesCategoriesSubscription: Subscription;
  resourceSubscription: Subscription;

  get myCustomPageActions() {
    return {
      printCalendar: {
        activated: true,
        type: 'action',
        icon: 'print', //'times',
        variant: 'primary',
        text: 'print',
        show: true,
        event: 'print-calendar',
        selectElements: false,
        buttonClass: !this.resourcesLoaded ? 'disabled' : '',
        disabled: !this.resourcesLoaded,
        tag: 'left',
        permissions: ['read'],
      },
      weekView: {
        activated: true,
        type: 'action',
        icon: 'calendar', //'times',
        variant: 'primary',
        text: 'calendar_week_view',
        show: true,
        event: 'week-view',
        selectElements: false,
        buttonClass: !this.resourcesLoaded ? 'disabled' : '',
        disabled: !this.resourcesLoaded,
        tag: 'left',
        permissions: ['read'],
      },
    };
  }

  get pageActions() {
    return {
      ...this.myCustomPageActions,
      ...this.defaultPageActions,
    };
  }

  public customRowActions = {};

  public stdFilterModel = {
    date: null,
    resource__sectors__id: null,
    discipline__id: null,
    exclusions_resource_id: null,
  };

  public resourcesSelectInfo = [];

  public showEventDrawerSection = false;
  public showEventForm = false;
  public bookingEvent: BookingEvent = null;

  public isSimpleBooking = true;
  public headingDate: string = '';

  public showBookingDrawerSection: boolean = false;
  public newPrice = 0;
  public originalPrice = 0;
  public newForcedPrice = 0;
  public suggestedUpdatedOrders = null;
  public noRefund = null;
  public filterSectorsLoaded: boolean = false;

  constructor() {
    super();
  }

  public get selectedDiscipline(): Discipline {
    return this.disciplines.find(
      discipline =>
        discipline.id ===
        (Array.isArray(this.selectedDisciplineId) === true
          ? this.selectedDisciplineId[0]
          : this.selectedDisciplineId),
    );
  }

  get startLoadingEntities(): boolean {
    return this.$store.getters[`${this.storeName}/loadingEntities`](this.entityName);
  }

  onEventFormClose() {
    this.$refs.fcalendar.getApi().unselect();
    this.showEventForm = false;
    this.showEventDrawerSection = false;
    this.i++;
  }

  onFormClose() {
    this.$refs.fcalendar.getApi().unselect();
    this.showForm = false;
    this.showDrawerSection = false;
    this.showEventDrawerSection = false;
    this.i++;
  }

  public get filterDate(): string {
    return this.stdFilterModel.date || moment().format('YYYY-MM-DD');
  }

  public get selectedSectorId(): number {
    return this.stdFilterModel.resource__sectors__id || null;
  }
  public get selectedDisciplineId(): number {
    return this.stdFilterModel.discipline__id || null;
  }

  public get slotMinTime() {
    return this.$store.getters['centerSettings/centerSettings']?.default_start_hour;
  }

  public get slotMaxTime() {
    return this.$store.getters['centerSettings/centerSettings']?.default_end_hour;
  }

  public get defaultSlotDuration() {
    const slotDuration =
      this.$store.getters['centerSettings/centerSettings']?.default_slot_duration || 30;
    const hours = Math.floor(slotDuration / 60);
    const minutes = slotDuration % 60 < 10 ? `0${slotDuration % 60}` : slotDuration % 60;

    return `${hours}:${minutes}:00`;
  }

  public get slotDuration() {
    return this.$store.getters['centerSettings/centerSettings']?.default_slot_duration || 30;
  }

  public get labelUpdateOrders() {
    return this.$t('bookings.booking_events.update_orders.confirmation_modal.label');
  }

  public get bookingEventStoreName() {
    return this.bookingEvent && this.bookingEvent.id
      ? `bookingEvent_${this.bookingEvent.id}`
      : 'bookingEvent';
  }

  public get bookingStoreName() {
    return `booking_0`;
  }

  public get bookingModel() {
    return this.$store.getters[`${this.bookingStoreName}/model`];
  }

  public get selectedResourceId(): number[] {
    return this.stdFilterModel.exclusions_resource_id || null;
  }

  private calendarOptions: CalendarOptions = {
    plugins: [
      resourceTimeGridPlugin,
      interactionPlugin,
      scrollGrid,
      adaptivePlugin,
      resourceTimelinePlugin,
    ],
    schedulerLicenseKey: process.env.VUE_APP_FULLCALENDAR_LICENCE_KEY,
    headerToolbar: {
      left: '',
      center: '',
      right: '',
    },
    resources: [],
    resourceOrder: 'ordering',
    resourceLabelDidMount: info => {
      // We add a new class resource-link to the HTMLElement
      const newClassArray = info.el.className.split(' ').concat(['resource-link']);
      info.el.className = newClassArray.join(' ');

      // We create a click event to redirect to the week-calendar
      // with the right resource_id param
      info.el.addEventListener('click', () => {
        router.push({
          name: 'admin-week-calendar',
          query: {
            resource_id: String(info.resource.id),
          },
        });
      });

      tippy(info.el, {
        content: info.resource.extendedProps.name,
      });
    },
    initialView: 'resourceTimeGrid',
    views: {
      resourceTimeGrid: {
        type: 'resourceTimeGrid',
        duration: { days: 1 },
      },
    },
    initialEvents: 'events', // alternatively, use the `events` setting to fetch from a feed
    // initialDate: this.filterDate,
    viewDidMount: this.gotoCurrentDate,
    editable: false,
    selectable: false,
    selectMirror: true,
    dayMaxEvents: true,
    weekends: true,
    unselectAuto: false,
    select: this.handleDateSelect,
    selectOverlap: this.handleConflictEvents,
    eventClick: this.handleEventChange,
    eventsSet: this.handleEvents,
    eventDrop: this.dragAndDropEventChange,
    eventResize: this.dragAndDropEventChange,
    eventOverlap: true,
    datesAboveResources: true,
    dayMinWidth: 100,
    allDaySlot: false,
    slotMinTime: this.slotMinTime,
    slotMaxTime: this.slotMaxTime,
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      omitZeroMinute: false,
      hour12: false,
      meridiem: false,
    },
    slotLabelFormat: {
      hour: '2-digit',
      minute: '2-digit',
      omitZeroMinute: false,
      hour12: false,
      meridiem: false,
    },
    slotDuration: this.defaultSlotDuration,
    height: 'auto',
    stickyHeaderDates: 'auto',
    nowIndicator: true,
    // Called right after the element has been added to the DOM.
    /*eventDidMount: function(event) {
      if (event.event._def.ui.classNames.includes('excluded-event')) {

      }
    },
    */
    // eventChange: this.handleEventChange,
    /* you can update a remote database when these fire:
    eventAdd:
    eventChange:
    eventRemove:
    */
  };

  public currentEvents: EventApi[] = [];
  private dragAndDropEvent: any = null;
  showUpdateOrdersAfterChangeOption: boolean = false;
  showReplaceConflictsAfterChangeOption: boolean = false;

  dragAndDropEventChange(e) {
    this.bookingEvent = null;
    this.showUpdateOrdersAfterChangeOption = false;
    this.showReplaceConflictsAfterChangeOption = false;
    this.dragAndDropEvent = e;
    this.$bvModal.show('confirmation-update-modal');
    this.$bpcApi
      .get(`${this.$bpcApiRouteHelper.getEntityPath('booking-event', 'raw')}/${e.event.id}`)
      .subscribe(res => {
        this.bookingEvent = res.data;

        const originalBookingEvent = JSON.parse(JSON.stringify(this.bookingEvent)); // Clone it to check changes
        const start = moment(e.event.start);
        const end = moment(e.event.end);
        const resourceId = e.event.getResources()[0] ? e.event.getResources()[0].id : null;
        const articleId = e.event.getResources()[0]
          ? e.event.getResources()[0].extendedProps.article_id
          : null;
        // Update booking event with new data from resource
        this.bookingEvent.start_time = start.format('HH:mm');
        this.bookingEvent.end_time = end.format('HH:mm');
        this.bookingEvent.date = start.format('YYYY-MM-DD');
        this.bookingEvent.resource_id = resourceId;
        this.bookingEvent.article_id = articleId;

        const basePath = this.$bpcApiRouteHelper.getEntityPath('booking-event');

        this.$bpcApi.post(basePath + '/get-price', this.bookingEvent).subscribe(res => {
          this.newPrice = res['event_price'].toFixed(2);
          this.originalPrice = res['original_event_price'].toFixed(2);
          this.newForcedPrice = res['event_forced_price'].toFixed(2);
          this.suggestedUpdatedOrders = res['suggested_updated_orders'];
          this.noRefund = res['no_refund'];

          this.showUpdateOrdersAfterChangeOption = this.checkShowUpdateOrdersAfterChangeOption(
            originalBookingEvent,
            this.bookingEvent,
          );

          this.showReplaceConflictsAfterChangeOption = this.checkShowReplaceConflictsAfterChangeOption(
            originalBookingEvent,
            this.bookingEvent,
          );
        });
      });
  }

  checkShowUpdateOrdersAfterChangeOption(
    bookingEvent: BookingEvent,
    bookingEventUpdated: BookingEvent,
  ): boolean {
    return (
      bookingEvent.resource_id !== bookingEventUpdated.resource_id ||
      bookingEvent.date !== bookingEventUpdated.date ||
      bookingEvent.start_time?.substr(0, 5) !== bookingEventUpdated.start_time?.substr(0, 5) ||
      bookingEvent.end_time?.substr(0, 5) !== bookingEventUpdated.end_time?.substr(0, 5) ||
      bookingEvent.article_id !== bookingEventUpdated.article_id ||
      bookingEvent.price_category_id !== bookingEventUpdated.price_category_id
    );
  }

  checkShowReplaceConflictsAfterChangeOption(
    bookingEvent: BookingEvent,
    bookingEventUpdated: BookingEvent,
  ): boolean {
    return (
      (bookingEvent.resource_id !== bookingEventUpdated.resource_id ||
        bookingEvent.date !== bookingEventUpdated.date ||
        bookingEvent.start_time?.substr(0, 5) !== bookingEventUpdated.start_time?.substr(0, 5) ||
        bookingEvent.end_time?.substr(0, 5) !== bookingEventUpdated.end_time?.substr(0, 5)) &&
      // If the event has been reduced and contained inside we have to avoid asking
      // First case: start equal and finish before
      !(
        bookingEventUpdated.start_time?.substr(0, 5) === bookingEvent.start_time?.substr(0, 5) &&
        bookingEventUpdated.end_time?.substr(0, 5) < bookingEvent.end_time?.substr(0, 5)
      ) &&
      // Second case: start later and finish equal
      !(
        bookingEventUpdated.start_time?.substr(0, 5) > bookingEvent.start_time?.substr(0, 5) &&
        bookingEventUpdated.end_time?.substr(0, 5) === bookingEvent.end_time?.substr(0, 5)
      ) &&
      // Third case: start later and finish before
      !(
        bookingEventUpdated.start_time?.substr(0, 5) > bookingEvent.start_time?.substr(0, 5) &&
        bookingEventUpdated.end_time?.substr(0, 5) < bookingEvent.end_time?.substr(0, 5)
      )
    );
  }

  handleEventChange(e) {
    this.$store.commit(`${this.bookingEventStoreName}/setCurrentAction`, 'edit'); // To indicate that we are not in the search of booking
    this.showForm = false;
    this.showDrawerSection = false;
    this.showEventForm = true;
    this.showEventDrawerSection = true;

    const event = this.items.find(event => event.id === Number(e.event.id));

    if (event) {
      this.bookingEvent = event;
    }

    this.$store
      .dispatch(`${this.bookingEventStoreName}/initializeFormModel`, {
        entity: 'booking-event',
        fetchEntity: this.bookingEvent ? true : false,
        id: this.bookingEvent.id,
        formName: 'default',
      })
      .then(res => {
        res.add(() => {
          setTimeout(() => {
            const start = moment(e.event.start);
            const end = moment(e.event.end);

            this.$store.commit(`${this.bookingEventStoreName}/setModelProp`, {
              prop: 'start_time',
              value: start.format('HH:mm'),
            });

            this.$store.commit(`${this.bookingEventStoreName}/setModelProp`, {
              prop: 'end_time',
              value: end.format('HH:mm'),
            });

            this.$store.commit(`${this.bookingEventStoreName}/setModelProp`, {
              prop: 'date',
              value: start.format('YYYY-MM-DD'),
            });

            console.log('RESOURCE', e.event.getResources());
            const resourceId = e.event.getResources()[0] ? e.event.getResources()[0].id : null;

            if (resourceId) {
              const resource = this.resources.find(resource => resource.id === Number(resourceId));
              this.$store.commit(`${this.bookingEventStoreName}/setModelProp`, {
                prop: 'resource',
                value: resource,
              });

              this.$store.commit(`${this.bookingEventStoreName}/setModelProp`, {
                prop: 'resource_id',
                value: resourceId,
              });
            }

            // this.$store.commit('${this.bookingStoreName}/setModel', model);
          }, 1000);
        });
      });
  }
  handleDateSelect(selectInfo: DateSelectArg) {
    this.$store.commit(`${this.bookingStoreName}/setCurrentAction`, 'new'); // To indicate that we are not in the search of booking
    this.$store.commit(`${this.bookingStoreName}/setInitialModel`, {
      fields: this.$store.getters[`${this.bookingStoreName}/fieldsObject`],
      model: {},
    });
    this.showEventDrawerSection = false;
    this.showEventForm = false;
    this.showForm = true;
    this.showDrawer();

    setTimeout(() => {
      const start = moment(selectInfo.startStr);
      const end = moment(selectInfo.endStr);
      const model = this.$store.getters[`${this.bookingStoreName}/model`];
      const resource = this.resources.find(
        resource => resource.id === Number(selectInfo.resource.id),
      );
      const discipline = this.selectedDiscipline;

      set(model, 'time_range.start_time', start.format('HH:mm'));
      set(model, 'start_date', start.format('YYYY-MM-DD'));
      set(model, 'date_range.start_date', start.format('YYYY-MM-DD'));
      set(model, 'time_range.end_time', end.format('HH:mm'));

      if (resource) {
        set(model, 'resources', [resource]);
        set(model, 'article', resource['article']);
        this.$root.$emit('updateSuggestedArticles', [resource]);
      }

      if (discipline) {
        set(model, 'discipline', discipline);
      }

      this.$store.commit(`${this.bookingStoreName}/setModel`, model);
    }, 2000);
  }

  // parseBookingToCalendarEvent(booking: Booking) {
  //   return {
  //     id: booking.id,
  //     title: booking.name
  //       ? booking.name
  //       : booking.contact && booking.contact['fullname']
  //       ? booking.contact['fullname']
  //       : booking.discipline && booking.discipline['name']
  //       ? booking.discipline['name']
  //       : '',
  //     booking_type: booking.booking_type,
  //     start: this.formatDateTime(booking.start_date, booking.start_time),
  //     end: this.formatDateTime(booking.start_date, booking.end_time),
  //     backgroundColor: booking['discipline'] ? booking['discipline']['color'] : null,
  //     borderColor: booking['discipline'] ? booking['discipline']['color'] : null,
  //     resourceId: `${booking.resources[0]['id']}`,
  //   };
  // }
  handleConflictEvents(e) {
    const res = e.classNames.includes('excluded-event');
    if (res) {
      this.$bpcMessage.showInfoMessage({ text: 'bookings.resource_exclusions_filtered' });
      this.$root.$emit('updateResource', {
        action: 'selectEntity',
        entity: 'resource',
        resource_id: e.extendedProps.resource_id,
      });
    }
    return !res;
  }

  get allEvents(): ParsedEvent[] {
    return this.events.concat(this.excludedEvents, this.backgroundEvents);
  }

  onEventFormSaved() {
    // this.allEvents = [];
    setTimeout(() => {
      this.$refs.provider.getEntities();
    }, 300);
    this.onEventFormClose();
    // this.$refs.provider.getEntities();
  }

  onFormSaved($event: any = null) {
    // this.allEvents = [];
    console.log('Booking Saved lets getEntities');
    setTimeout(() => {
      this.$refs.provider.getEntities();
    }, 300);
    this.onFormClose();
    if (this.nextAction === 'pay') {
      const orders = [];
      $event.data?.bookingEvents?.forEach(bookingEvent => {
        bookingEvent.orders.forEach(order => orders.push(order));
      });
      this.ordersAvailableToPosCheckout = orders;
      this.selectedOrdersToPosCheckout = orders;
      this.selectedContactIdToPosCheckout = $event.data.contact_id;
      this.selectedPriceCategoryIdToPosCheckout = $event.data.price_category_id;
      this.selectedInvoiceIdToPosCheckout = this.$store.getters['pos/currentTicketId'];
      this.openExportPosCheckoutModal();
    }
    this.setNextAction('');
  }

  getEntitiesOnce() {
    if (this.startLoadingEntities !== true) {
      this.$refs.provider.getEntities();
    }
  }

  showDrawer() {
    this.$store.commit(`${this.bookingStoreName}/setIsDirty`, false);
    this.showDrawerSection = true;
  }

  // onFormSave() {
  //   this.savingOrSearchingForm = true;
  //   console.log('Saving');
  //   this.allEvents = [];
  //   this.nextAction = '';
  //   this.$refs.stdForm.saveEntity();
  // }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

  customOnPageAction($event: string) {
    if ($event === 'week-view') {
      const resourceId = this.resources[0].id;

      this.$router.push({
        name: 'admin-week-calendar',
        query: {
          resource_id: String(resourceId),
        },
      });
    }

    if ($event === 'print-calendar') {
      this.$refs.fcalendar.getApi().changeView('resourceTimeline');
      this.$refs.fcalendar.getApi().setOption('resourceAreaWidth', '10%');
      this.$refs.fcalendar.getApi().setOption('nowIndicator', false);
      window.print();
    }
  }
  // onFormSearch() {
  //   this.savingOrSearchingForm = true;
  //   this.$refs.stdForm.searchEntity();
  //   this.resourcesSelectInfo = [];
  //   this.$bpcStorage.clear('booking-events');
  // }

  getResources() {
    this.resourcesLoaded = false;

    const params = {
      per_page: 500,
      orderBy: 'ordering',
      orderDirection: 'asc',
      contentForSelector: true,
      columns: ['id', 'center_id', 'name', 'code', 'ordering', 'article_id'],
      relationFields: ['article.id', 'article.name', 'article.code'],
      include: ['article'],
    };

    if (this.selectedSectorId) {
      params['sectors__id'] = this.selectedSectorId;
    }

    if (this.selectedDisciplineId) {
      params['disciplines__id'] = this.selectedDisciplineId;
    }

    if (this.selectedResourceId) {
      params['exclusions_resource_id'] = Array.isArray(this.selectedResourceId)
        ? this.selectedResourceId
        : [this.selectedResourceId];
      params['resources_with_exclusions'] = this.showResourcesWithExclusionsCanBeShown
        ? this.showResourcesWithExclusions
        : false;
    }

    if (this.resourceSubscription) {
      // NOTE: if there is other call to bring the resources
      // we unsubscribe from it to avoid race problems
      this.resourceSubscription.unsubscribe();
    }
    this.resourceSubscription = this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('resource'), {
        params: params,
      })
      .subscribe(res => {
        console.log('resource', res);
        this.resources = res.data;
        this.$set(this.calendarOptions, 'resources', this.parseResources(this.resources));
        this.resourcesLoaded = true;
        this.getDisciplines();
      });
  }

  getDisciplines() {
    const params = {
      per_page: -1,
      resources_id: this.resources.map(resource => {
        return resource.id;
      }),
      columns: [
        'id',
        'name',
        'code',
        'center_id',
        'enable_multiplayer_booking',
        'multiplayer_allow_guests',
        'number_of_players',
        'multiplayer_max_guests',
      ],
    };
    params['resources__id'] = this.resources.map(resource => {
      return resource.id;
    });

    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('discipline'), {
        params: params,
      })
      .subscribe(res => {
        console.log('discipline', res);
        this.disciplines = res.data;
      });
  }

  parseResources(resources: Resource[]) {
    return resources.map(resource => {
      return {
        id: `${resource.id}`,
        title: resource.code,
        name: resource.name,
        ordering: resource.ordering,
        article_id: resource.article_id,
        article: resource.article,
      };
    });
  }

  onStartLoadingEntities() {
    this.getResourceConflicts();
    this.getSlotPricesCategories();
  }

  async getSlotPricesCategories(): Promise<void> {
    // The filter date is not refreshed when make the call so when you change the day of the calendar,
    // the slot prices categories are not shown. To fix it it is necessary to add "await this.$nextTick();"
    await this.$nextTick();
    return new Promise((resolve, reject) => {
      if (!this.filterDate) {
        return;
      }
      this.loadingSlotCategories = true;

      const params = {
        date: this.filterDate,
        with_resources: true,
      };
      if (this.slotPricesCategoriesSubscription) {
        // NOTE: if there is other call to bring the slot categories
        // we unsubscribe from it to avoid race problems
        this.slotPricesCategoriesSubscription.unsubscribe();
      }
      this.slotPricesCategoriesSubscription = this.$bpcApi
        .get(this.$bpcApiRouteHelper.getEntityPath('schedule-slot-ranges') + '/ranges-by-date', {
          params: params,
        })
        .subscribe(
          res => {
            this.backgroundEvents = this.addSlotCategoriesAsBackgroundEvents(res.data, params.date);
            this.$set(this.calendarOptions, 'events', this.allEvents);
            if (this.$refs.fcalendar) {
              this.$refs.fcalendar.$emit('rerender-events');
            }
            this.loadingSlotCategories = false;
            resolve();
          },
          error => {
            this.loadingSlotCategories = false;
            reject(error);
          },
        );
    });
  }

  addSlotCategoriesAsBackgroundEvents(
    scheduleSlotRangeCollection: ScheduleSlotRange[],
    date: string,
  ): ParsedEvent[] {
    return scheduleSlotRangeCollection.reduce((backgroundEvents: ParsedEvent[], slot) => {
      const defaultBookingResourceIds = slot.default_resources;

      const defaultSchedules = this.addBackgroundEventsFromSlot(
        slot,
        defaultBookingResourceIds,
        date,
      );

      backgroundEvents = backgroundEvents.concat(defaultSchedules);
      return backgroundEvents;
    }, []);
  }

  addBackgroundEventsFromSlot(
    slot: ScheduleSlotRange,
    resourceIds: number[],
    date: string,
  ): ParsedEvent[] {
    return resourceIds.map(resourceId => {
      return {
        start: this.formatDateTime(date, slot.start_time),
        end: this.formatDateTime(date, slot.end_time),
        backgroundColor: `${slot.color}`,
        borderColor: `${slot.color}`,
        display: 'background',
        resourceId: resourceId,
      };
    });
  }

  async getResourceConflicts() {
    return new Promise((resolve, reject) => {
      this.loadingConflicts = true;
      const params = this.$refs.provider.queryConfig.params;
      if (this.resourceConflictSubscription) {
        // NOTE: if there is other call to bring the conflicts
        // we unsubscribe from it to avoid race problems
        this.resourceConflictSubscription.unsubscribe();
      }
      this.resourceConflictSubscription = this.$bpcApi
        .get(this.$bpcApiRouteHelper.getEntityPath('booking-event') + '/resource-conflicts', {
          params,
        })
        .subscribe(
          res => {
            const excludedEvents = res.data.map(excludedEvent => {
              return {
                id: excludedEvent.id,
                title: excludedEvent.name,
                start: this.formatDateTime(excludedEvent.date, excludedEvent.start_time),
                end: this.formatDateTime(excludedEvent.date, excludedEvent.end_time),
                backgroundColor: '#cecece',
                borderColor: '#cecece',
                resourceId: `${excludedEvent.resource_id}`,
                className: ['excluded-event'],
                display: 'background',
                extendedProps: {
                  resource_id: excludedEvent.resource_id,
                },
              };
            });
            this.excludedEvents = excludedEvents;
            this.$set(this.calendarOptions, 'events', this.allEvents);
            if (this.$refs.fcalendar) {
              this.$refs.fcalendar.$emit('rerender-events');
            }
            this.loadingConflicts = false;
            resolve(true);
          },
          error => {
            this.loadingConflicts = false;
            reject(error);
          },
        );
    });
  }

  get displayEventsWithContactColor() {
    return this.$store.getters['centerSettings/displayContactColorInBookingCalendar'];
  }

  parseBookingEventToCalendarEvent(event: BookingEvent) {
    const color = this.displayEventsWithContactColor
      ? event.contact?.color
      : event?.discipline?.color;
    return {
      id: event.id,
      title: event.name
        ? event.name
        : event.contact && event.contact['fullname']
        ? event.contact['fullname']
        : event.discipline && event.discipline['name']
        ? event.discipline['name']
        : '',
      booking_type: event.booking_type,
      start: this.formatDateTime(event.date, event.start_time),
      end: this.formatDateTime(event.date, event.end_time),
      backgroundColor: color,
      borderColor: color,
      resourceId: `${event.resource_id}`,
      classNames: [
        `booking-type-${event.booking_type}`,
        `booking-status-${event.status}`,
        event.status === 'requested' ? `booking-show-requested-${this.showRequestedBookings}` : '',
      ],
    };
  }

  addEventsToCalendar() {
    this.items = this.$refs.provider ? this.$refs.provider.items : null;
    const events = this.items.map(event => {
      return this.parseBookingEventToCalendarEvent(event);
    });
    console.log('events', events);
    this.events = events;
    this.$set(this.calendarOptions, 'events', this.allEvents);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.getApi().unselect();
      this.$refs.fcalendar.$emit('rerender-events');
    }
    // this.calendarOptions.eventsSet;
  }

  gotoCurrentDate() {
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.getApi().gotoDate(this.filterDate);
    }
  }

  formatDateTime(date, time): string {
    return moment(`${date} ${time}`).toISOString();
  }

  hasBookingEvents(): boolean {
    return this.isSimpleBooking
      ? false
      : !!this.$store.getters[`${this.bookingStoreName}/model`].bookingEvents;
  }

  onFormSearched() {
    // this.showSelectResourceModalIfNeccesary();
    // this.$set(this.$refs.stdForm.$refs.formProvider.model, 'action', 'new');
    // this.currentAction = 'search'; // To indicate that we are not in the search of booking
  }

  syncDateFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.updateHeadingDate(model.date);
      this.$set(this.stdFilterModel, 'date', model.date || null);
    }
  }

  syncSectorFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.$set(this.stdFilterModel, 'resource__sectors__id', model.resource__sectors__id || null);
    }
  }

  syncDisciplineFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.$set(this.stdFilterModel, 'discipline__id', model.resource_discipline_id || null);
    }
  }

  syncResourceFilterModel(model) {
    console.log('syncFilterModel', model);
    if (model) {
      this.$set(
        this.stdFilterModel,
        'exclusions_resource_id',
        model.exclusions_resource_id || null,
      );
    }
  }

  updateHeadingDate(date) {
    this.headingDate = '';
    if (date) {
      const locale = this.getLang() === 'be' ? 'fr' : this.getLang();

      this.headingDate = moment(date)
        .locale(locale)
        .format('dddd DD/MM/YYYY')
        .toUpperCase();
    }
  }

  // get isSimpleBooking() {
  //   const model = this.$store.getters[`${this.bookingStoreName}/model`];
  //   const repetitive = model.repetitive ? model.repetitive : false;
  //   return repetitive;
  // }

  /* Lifecycle hooks */

  // created () { }
  mounted() {
    this.exportCheckoutModalId = this.generateUUIDv4();
    this.$root.$on('bookingEventSaved', event => {
      this.getEntitiesOnce();
    });
    this.$root.$on('bookingSaved', event => {
      this.getEntitiesOnce();
    });
    this.calendarOptions.editable = this.canManageEntity;
    this.calendarOptions.selectable = this.canManageEntity;
    this.$root.$on('refresh-form-after-add-orders-to-pos', () => {
      this.i++;
    });

    this.$root.$on('sector-tabs-loaded', event => {
      this.filterSectorsLoaded = true;
    });

    window.addEventListener('afterprint', this.restoreCalendar);
  }

  // updated () { }
  destroyed() {
    this.$root.$off('bookingEventSaved');
    this.$root.$off('bookingSaved');
    this.$root.$off('refresh-form-after-add-orders-to-pos');
    this.$root.$off('sector-tabs-loaded');
    window.removeEventListener('afterprint', this.restoreCalendar);
  }

  restoreCalendar() {
    setTimeout(() => {
      this.$refs.fcalendar.getApi().setOption('nowIndicator', true);
      this.$refs.fcalendar.getApi().changeView('resourceTimeGrid');
    }, 500);
  }

  onActionDelete(item) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(item.item['id']);
    this.showEventDrawerSection = false;
  }

  cancelingBookingEvents: boolean = false;
  repetitiveActionOptionSelected: string = null;
  repetitiveActionOptions: Record<string, any> = [
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.only'),
      value: 'only_this',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.next_same_events',
      ),
      value: 'next_same',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.all_same_events',
      ),
      value: 'all_same',
    },
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.all_events'),
      value: 'cancel_all',
    },
  ];

  onActionCancel(item) {
    this.cancelingBookingEvents = false;
    this.repetitiveActionOptionSelected = 'only_this';
    this.selectedRowEntity = item.item ? item.item : item;
    this.showEventDrawerSection = false;
    this.$bvModal.show('modal-cancel-action-event');
  }

  onConfirmCancelEvent() {
    this.cancelingBookingEvents = true;
    const hasCancelOwnPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'cancel',
      true,
    );

    let canBeCancelled = true;
    if (hasCancelOwnPermission) {
      canBeCancelled = this.checkIfBookingCanBeCancelled(this.selectedRowEntity);
    }

    if (canBeCancelled) {
      const basePath = this.$bpcApiRouteHelper.getEntityPath('booking-event');
      const relativePath = '/cancel/' + this.selectedRowEntity.id;

      this.$bpcApi
        .post(basePath + relativePath, {
          id: this.selectedRowEntity.id,
          cancelReason: this.$authorizationService.hasPermissionForAction(
            this.permissionEntityNameToUse,
            'cancel',
          )
            ? this.$refs.stdCancelForm.formModel['cancel_reason']
            : 'customer',
          cancelReasonDescription: this.$refs.stdCancelForm.formModel['cancel_reason_description'],
          cancelOrders: this.$refs.stdCancelForm.formModel['cancel_orders'],
          notify_by_email:
            'notify_by_email' in this.$refs.stdCancelForm.formModel
              ? this.$refs.stdCancelForm.formModel['notify_by_email']
              : true,
          actionForRepetitive: this.repetitiveActionOptionSelected,
        })
        .subscribe(
          res => {
            this.selectedRowEntity = null;
            this.$refs.provider.getEntities();
            this.$bvModal.hide('modal-cancel-action-event');
            this.cancelingBookingEvents = false;
          },
          error => {
            this.selectedRowEntity = null;
            this.$bvModal.hide('modal-cancel-action-event');
            this.cancelingBookingEvents = false;
          },
        );
    } else {
      this.cancelingBookingEvents = false;
      const diffInMinutes = moment(
        `${this.selectedRowEntity.date} ${this.selectedRowEntity.start_time}`,
      ).diff(moment(), 'minutes');

      const bookingOption = this.$authService.getIsIndividual()
        ? this.selectedRowEntity.booking_options
        : this.selectedRowEntity.booking_options_for_organization;

      this.$bvModal.msgBoxOk(
        this.$t('global.modals.public_booking.cancellation.not_possible', {
          minTime: moment()
            .subtract(
              Math.abs(
                diffInMinutes - 60 * bookingOption?.fixed_options?.min_time_before_cancellation + 1,
              ),
              'minutes',
            )
            .format('DD/MM/YYYY HH:mm'),
        }).toString(),
        {
          title: this.$t('global.modals.public_booking.cancellation.title').toString(),
          okTitle: this.$t('global.buttons.close').toString(),
        },
      );
    }
  }

  checkIfBookingCanBeCancelled(bookingEvent: BookingEvent): boolean {
    const diffInMinutes = moment(`${bookingEvent.date} ${bookingEvent.start_time}`).diff(
      moment(),
      'minutes',
    );
    const bookingOption = this.$authService.getIsIndividual()
      ? bookingEvent.booking_options
      : bookingEvent.booking_options_for_organization;
    return diffInMinutes >= 60 * (bookingOption?.fixed_options?.min_time_before_cancellation || 0);
  }

  onCloseModal() {
    this.selectedRowEntity = null;
    this.$bvModal.hide('modal-cancel-action-event');
  }

  private getParamsThatCanGetResources() {
    return [this.selectedSectorId, this.selectedDisciplineId, this.selectedResourceId].join(',');
  }

  getResourcesIfNothingChange() {
    const oldParamsThatCanGetResources = this.getParamsThatCanGetResources();
    setTimeout(() => {
      const newParamsThatCanGetResources = this.getParamsThatCanGetResources();
      if (newParamsThatCanGetResources === oldParamsThatCanGetResources) {
        this.getResources();
      }
    }, 300);
  }

  onChangeFilter() {
    if (
      this.$refs.provider &&
      this.$refs.provider.canLoadEntities &&
      this.$refs.provider.firstLoadEntities
    ) {
      let changed = false;
      changed = this.setQueryConfigParams();
      if (changed) {
        if (!this.ignoreURLParams) {
          this.$router.push({ query: this.$refs.provider.queryConfig.params }).catch(e => {
            return null;
          });
        }

        if (this.filterModel.date) {
          // Date mandatory to load bookings
          if (this.$refs.provider.pagination.current_page !== 1) {
            this.$set(this.$refs.provider.pagination, 'current_page', 1);
          } else {
            this.$refs.provider.getEntities();
            this.updatePageActions();
            this.updateRowActions();
          }
        }
      }
    }
  }

  // updated () { }

  @Watch('filterDate')
  onChangeFilterDate() {
    this.gotoCurrentDate();
  }

  @Watch('selectedSectorId')
  onChangeSelectedSectorId() {
    this.getResourcesIfNothingChange();
  }

  @Watch('selectedDisciplineId')
  onChangeSelectedDisciplineId(val) {
    this.getResourcesIfNothingChange();
  }

  @Watch('selectedResourceId')
  onChangeSelectedResourceId(val) {
    this.getResourcesIfNothingChange();
  }

  @Watch('slotMinTime')
  onChangeSlotMinTime() {
    this.$set(this.calendarOptions, 'slotMinTime', this.slotMinTime);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  @Watch('slotMaxTime')
  onChangeSlotMaxTime() {
    this.$set(this.calendarOptions, 'slotMaxTime', this.slotMaxTime);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  @Watch('slotDuration')
  onChangeSlotDuration() {
    const hours = Math.floor(this.slotDuration / 60);
    const minutes =
      this.slotDuration % 60 < 10 ? `0${this.slotDuration % 60}` : this.slotDuration % 60;
    const slotDurationFormated = `${hours}:${minutes}:00`;
    this.$set(this.calendarOptions, 'slotDuration', slotDurationFormated);
    if (this.$refs.fcalendar) {
      this.$refs.fcalendar.$emit('render');
    }
  }

  /**
   * Functions for booking forms
   */
  onNew() {
    this.entity = null;
    this.$bpcStorage.clear('booking-events');
    this.showForm = true;
    this.isSimpleBooking = true;
    this.showDrawer();

    setTimeout(() => {
      this.$store.commit(`${this.bookingStoreName}/setInitialModel`, {
        fields: this.$store.getters[`${this.bookingStoreName}/fieldsObject`],
        model: {},
      });

      const model = this.$store.getters[`${this.bookingStoreName}/model`];
      const discipline = this.selectedDiscipline;

      if (discipline) {
        set(model, 'discipline', discipline);
      }

      set(model, 'start_date', this.filterDate);
      set(model, 'date_range.start_date', this.filterDate);

      this.$store.commit(`${this.bookingStoreName}/setModel`, model);
    }, 2000);
  }

  getBookingModalTitle() {
    return this.$t('global.modals.create') + ' ' + this.$t('global.models.booking.name');
  }

  // Modal confirmation for update booking events when make drag and drop
  actionOptionSelected: string = null;
  actionOptions: Record<string, any> = [];
  conflictOptionSelected: string = null;
  conflictOptions: Record<string, any> = [];
  orderOptionSelected: string = null;
  orderOptions: Record<string, any> = [];
  sendEmailOptions: Record<string, any> = [];
  sendEmailOptionSelected: boolean = this.defaultSendBookingEventChangeEmail;

  get defaultSendBookingEventChangeEmail(): boolean {
    return !!this.$store.getters['centerSettings/centerSettings']
      ?.admin_send_booking_event_change_email;
  }

  get showSendEmailOption(): boolean {
    return (
      this.$store.getters['centerSettings/centerSettings']?.send_booking_event_change_email &&
      this.bookingEvent.status === 'confirmed'
    );
  }

  public get confirmationUpdateModalTitle() {
    return this.$t('global.modals.update-booking-event.multiple.title');
  }

  public get actionOptionsLabel() {
    return this.$t('global.modals.update-booking-event.multiple.action_option.label');
  }

  public get conflictOptionsLabel() {
    return this.$t('global.modals.update-booking-event.multiple.conflicts_case.label');
  }

  public get orderOptionsLabel() {
    return this.$t('global.modals.update-booking-event.multiple.orders.label');
  }

  public get sendEmailOptionsLabel() {
    return this.$t('global.modals.update-booking-event.send_email.label');
  }

  public get confirmButtonText() {
    return this.$t('global.buttons.confirm');
  }

  public get cancelButtonText() {
    return this.$t('global.buttons.cancel');
  }

  public get profileCanChangeOrders() {
    return this.$authorizationService.hasPermission('force_price_update_booking');
  }

  resetConfirmationUpdateModal() {
    this.actionOptions = [
      {
        text: this.$t('global.modals.update-booking-event.multiple.action_option.options.only'),
        value: 'only_this',
      },
      {
        text: this.$t(
          'global.modals.update-booking-event.multiple.action_option.options.next_same_events',
        ),
        value: 'next_same',
      },
      {
        text: this.$t(
          'global.modals.update-booking-event.multiple.action_option.options.all_same_events',
        ),
        value: 'all_same',
      },
    ];

    this.actionOptionSelected = 'only_this';

    this.conflictOptions = [
      {
        text: this.$t('global.modals.update-booking-event.multiple.conflicts_case.options.replace'),
        value: 'replace',
      },
      {
        text: this.$t(
          'global.modals.update-booking-event.multiple.conflicts_case.options.do_nothing',
        ),
        value: 'do_nothing',
      },
    ];

    this.conflictOptionSelected = 'replace';

    this.orderOptions = [
      {
        text: this.$t('global.modals.update-booking-event.multiple.orders.options.update'),
        value: 'update',
      },
      {
        text: this.$t('global.modals.update-booking-event.multiple.orders.options.no_update'),
        value: 'no_update',
      },
    ];

    this.orderOptionSelected = 'update';

    this.sendEmailOptions = [
      {
        text: this.$t('global.send_email_option.yes'),
        value: true,
      },
      {
        text: this.$t('global.no'),
        value: false,
      },
    ];

    this.sendEmailOptionSelected = this.defaultSendBookingEventChangeEmail;
  }

  onCancelUpdateEventModal() {
    this.dragAndDropEvent.revert();
    this.dragAndDropEvent = null;
  }

  onConfirmUpdateEventModal() {
    // If the options are not available to select, set by default values to avoid the action
    if (!this.showReplaceConflictsAfterChangeOption) {
      this.conflictOptionSelected = 'do_nothing';
    }
    if (!this.showUpdateOrdersAfterChangeOption) {
      this.orderOptionSelected = 'no_update';
    }

    if (this.bookingEvent.own_to_repetitive_booking) {
      this.bookingEvent.action_for_update = this.actionOptionSelected;
      this.bookingEvent.action_for_conflicts = this.conflictOptionSelected;
    }
    this.bookingEvent.action_for_orders = this.orderOptionSelected;
    this.bookingEvent.notify_by_email = this.sendEmailOptionSelected;

    const updateEventObservable: Observable<BPCGenericApiResponse> = this.$bpcApi.put(
      `${this.$bpcApiRouteHelper.getEntityPath('booking-event')}/${this.bookingEvent.id}`,
      this.bookingEvent,
      null,
    );

    updateEventObservable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.$refs.provider.getEntities();
      },
      error => {
        this.$bvModal.hide('confirmation-update-modal');
        this.bookingEvent = null;
        this.$bpcMessage.showErrorMessage({ text: 'global.generic.error_update_action' });
        this.dragAndDropEvent.revert();
      },
      () => {
        this.bookingEvent = null;
        this.$bvModal.hide('confirmation-update-modal');
        this.events = this.$refs.provider.items;
      },
    );
  }

  /* Refuse booking event */
  showRefuseModal: boolean = false;
  eventIdsToRefuse: string[] | number[] = [];
  eventToRefuseOwnsToRepetitive: boolean = false;
  onActionRefuse(item): void {
    this.eventIdsToRefuse = [item.id];
    this.eventToRefuseOwnsToRepetitive = item.booking?.repetitive || false;
    this.showRefuseModal = true;
  }

  onCloseRefuseModal(): void {
    this.showRefuseModal = false;
    // Reset default data
    this.eventIdsToRefuse = [];
    this.eventToRefuseOwnsToRepetitive = false;
  }

  onSuccessRefuse(): void {
    this.i++;
    this.$refs.provider.getEntities();
  }

  /* Confirm booking event */
  showConfirmModal: boolean = false;
  eventIdsToConfirm: string[] | number[] = [];
  eventToConfirmOwnsToRepetitive: boolean = false;
  onActionConfirm(item): void {
    this.eventIdsToConfirm = [item.id];
    this.eventToConfirmOwnsToRepetitive = item.booking?.repetitive || false;
    this.showConfirmModal = true;
  }

  onCloseConfirmModal(): void {
    this.showConfirmModal = false;
    // Reset default data
    this.eventIdsToConfirm = [];
    this.eventToConfirmOwnsToRepetitive = false;
  }

  onSuccessConfirm(): void {
    this.i++;
    this.$refs.provider.getEntities();
  }

  // End modal confirmation for update booking events when make drag and drop

  /**
   * TODO activate this to be able to render the event in edition after getEntities
   *
   */

  /**
  addTmpEventInEdition() {
    if (this.tmpEventInEdition) {
      this.allEvents.push(this.tmpEventInEdition);
      this.$set(this.calendarOptions, 'events', this.allEvents);
      if (this.$refs.fcalendar) {
        this.$refs.fcalendar.$emit('rerender-events');
      }
    }
  }

  public get tmpEventInEdition() {
    if (this.bookingModel && !this.bookingModelHasDateAndTimeFields) {
      return this.parseBookingToCalendarEvent(this.bookingModel);
    }

    return null;
  }

  public get bookingModelHasDateAndTimeFields(): boolean {
    return (
      this.bookingModel.start_date && this.bookingModel.start_time && this.bookingModel.end_time
    );
  }
   */

  get calendarFetchPath(): string {
    const tenantId = this.$store.getters['tenant/selectedTenantId'];
    return `${tenantId}/src/booking-events/calendar`;
  }

  showResourcesWithExclusions: boolean = true;
  get showResourcesWithExclusionsCanBeShown() {
    return this.selectedResourceId
      ? Array.isArray(this.selectedResourceId)
        ? this.selectedResourceId.length === 1
        : this.selectedResourceId
      : false;
  }

  showRequestedBookings: boolean = true;

  onCancelledBookingEvent() {
    this.onRefresh();
  }

  @Watch('showRequestedBookings')
  onChangeShowRequestedBookings() {
    this.addEventsToCalendar();
  }

  @Watch('showResourcesWithExclusions')
  onShowResourcesWithExclusions() {
    if (this.showResourcesWithExclusionsCanBeShown) {
      this.getResourcesIfNothingChange();
    }
  }

  @Watch('filterSectorsLoaded')
  onChangeFilterSectorsLoaded() {
    if (!this.selectedSectorId) {
      this.getResourcesIfNothingChange();
    }
  }
}
